module.exports = __webpack_public_path__ + "6c51cb97d1ebeadd465bacf027e55303.woff";